import { render } from "./SSOEdit.vue?vue&type=template&id=2b68a1d9"
import script from "./SSOEdit.vue?vue&type=script&lang=js"
export * from "./SSOEdit.vue?vue&type=script&lang=js"

import "./SSOEdit.vue?vue&type=style&index=0&id=2b68a1d9&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.27.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__